import { render, staticRenderFns } from "./LicenseTypeSelectWidget.vue?vue&type=template&id=40d6a0f8&scoped=true&lang=pug&"
import script from "./LicenseTypeSelectWidget.vue?vue&type=script&lang=js&"
export * from "./LicenseTypeSelectWidget.vue?vue&type=script&lang=js&"
import style0 from "./LicenseTypeSelectWidget.vue?vue&type=style&index=0&id=40d6a0f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6a0f8",
  null
  
)

export default component.exports